/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import clsx from 'clsx';
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { TabContext, TabList } from '@mui/lab';
import { useParams } from "react-router-dom";
import { Box, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SalesPrice from "./SalesPrice";
import { SalesPriceHead, PurchasePriceHead, SalesDiscountHead, QuantityDiscountHead } from "../../../../../config/constant";
import SalesDiscount from "./SalesDiscount";
import PurchasePrice from "./PurchasePrice";
import QuantityDiscount from "./QuantityDiscount";
import purchaseActions from "../../../../Purchase/Management/redux/actions";
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import { idNamingConversion } from "../../../../../helpers/utilities";


const Price = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getLoader } = useSelector(state => state.crudReducer);

    const [value, setValue] = useState('');
    const [icon, setIcon] = useState('');
    const [links, setLinks] = useState([]);
    const [title, setTitle] = useState('');
    const [select, setSelect] = useState('');
    const [heads, setHeads] = useState(SalesPriceHead);
    const { history } = props;
    const dispatch = useDispatch();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 'sales-price' || newValue === 'sales-discount') {
            if (newValue === 'sales-price') {
                setHeads(SalesPriceHead);
            } else {
                setHeads(SalesDiscountHead);
            }
        } else if (newValue === 'purchase-price') {
            setHeads(PurchasePriceHead);
        } else if (newValue === 'sales-quantity-discount') {
            setHeads(QuantityDiscountHead);
        }
    };
    const { type } = useParams();

    useEffect(() => {
        loadTasks();
    }, []);

    const loadTasks = useCallback(() => {
        dispatch({
            type: purchaseActions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
                order: 'id desc'
            }
        });
        // dispatch({
        //     type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
        //         where: { "and": [{ status: 'ACTIVE' }] },
        //         order: 'id  desc'
        //     }
        // });
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id desc'
            }
        });

    });

    useEffect(() => {
        if (type === 'sales-price' || type === 'sales-discount') {
            setIcon(SalesIcon);
            setValue(type);
            if (type === 'sales-price') {
                setHeads(SalesPriceHead);
            } else {
                setHeads(SalesDiscountHead);
            }
            setSelect(type);
            setTitle('Sales');
            setLinks([{ 'label': 'Sales', 'link': '/sales' }, { 'label': type === 'sales-price' ? 'Customer Sales Price' : 'Customer Sales Discount', 'link': '' }]);
            setIcon(SalesIcon);
        } else if (type === 'purchase-price') {
            setIcon(PurchaseIcon);
            setTitle('Purchase');
            setValue(type);
            setHeads(PurchasePriceHead);
            setSelect(type);
            setLinks([{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Purchase Price', 'link': '' }]);
        } else if (type === 'maintain-price') {
            setIcon(SettingsImg);
            setValue('sales-price');
            setHeads(SalesPriceHead);
            setSelect(type);
            setTitle('Product');
            setLinks([{ 'label': 'Product', 'link': '/product' }, { 'label': 'Maintain Price', 'link': '' }]);
        }
    }, [type]);

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'} img={icon} title={title} links={links} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.tabInsideTable)}>
                <PrimaryCard
                    title={links[1]?.label}
                    component={
                        <TabContext value={value}>
                            <Box className={classes.tabDesign}>
                                <TabList onChange={handleChange}>
                                    {
                                        (select === 'sales-price' || select === 'sales-discount' || select === 'maintain-price') &&
                                        <Tab id={idNamingConversion('Sales Price', 'salesPrice', 'Link')} disabled={getLoader} className={classes.Bordertab_1} label="Sales Price" value={'sales-price'} />
                                    }
                                    {
                                        (select === 'sales-price' || select === 'sales-discount' || select === 'maintain-price') &&
                                        <Tab id={idNamingConversion('Sales Discount', 'salesPrice', 'Link')} className={classes.Bordertab_2} disabled={getLoader}
                                            label="Sales Discount" value={'sales-discount'} />
                                    }
                                    {
                                        (select === 'maintain-price') &&
                                        <Tab id={idNamingConversion('Sales Quantity Discount', 'salesPrice', 'Link')} className={classes.Bordertab_2} disabled={getLoader} label="Sales Quantity Discount" value={'sales-quantity-discount'} />
                                    }
                                    {
                                        (select === 'purchase-price' || select === 'maintain-price') &&
                                        <Tab id={idNamingConversion('Purchase Price', 'salesPrice', 'Link')} className={classes.Bordertab_2} disabled={getLoader} label="Purchase Price" value={'purchase-price'} />
                                    }

                                </TabList>
                            </Box>
                            {
                                value === 'sales-price' && <SalesPrice history={history}
                                    roleManagement={roleManagement}
                                    topBarView={true}
                                    title={value.replace("-", " ")}
                                    heads={heads} />
                            }
                            {
                                value === 'sales-discount' && <SalesDiscount history={history}
                                    roleManagement={roleManagement}
                                    topBarView={true}
                                    title={value.replace("-", " ")}
                                    heads={heads} />
                            }
                            {
                                value === 'purchase-price' && <PurchasePrice history={history}
                                    roleManagement={roleManagement}
                                    topBarView={true}
                                    title={value.replace("-", " ")}
                                    heads={heads} />
                            }
                            {
                                value === 'sales-quantity-discount' && <QuantityDiscount history={history}
                                    roleManagement={roleManagement}
                                    topBarView={true}
                                    title={value.replace("-", " ")}
                                    heads={heads} />
                            }
                        </TabContext>
                    }
                />
            </div>
        </React.Fragment>
    )
}

export default Price